import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRightIcon, SparklesIcon, ClockIcon } from 'lucide-react';
export function PriceSection() {
  return <section id="pricing" className="bg-gradient-to-b from-[#1B2A4A] via-[#1B2A4A] to-[#0F1829] text-white py-32 px-6 relative overflow-hidden" data-id="element-252">
      {/* Enhanced Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-253">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#F5A623] rounded-full blur-3xl opacity-20 animate-pulse" data-id="element-254"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[#3BBFAD] rounded-full blur-3xl opacity-20" data-id="element-255"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#F5A623] rounded-full blur-3xl opacity-10" data-id="element-256"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-257">
        <FadeIn data-id="element-258">
          {/* Urgency Badge */}
          <div className="flex justify-center mb-8" data-id="element-259">
            <div className="inline-flex items-center gap-2 bg-[#F5A623] text-white px-6 py-3 rounded-full shadow-lg animate-pulse" data-id="element-260">
              <ClockIcon className="w-5 h-5" data-id="element-261" />
              <span className="font-bold text-sm uppercase tracking-wide" data-id="element-262">
                Oferta de Lanzamiento - Tiempo Limitado
              </span>
            </div>
          </div>

          {/* Price Card */}
          <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-10 md:p-16 border-2 border-[#F5A623]/30 shadow-2xl relative overflow-hidden" data-id="element-263">
            {/* Decorative corner accents */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#F5A623]/20 rounded-full blur-3xl" data-id="element-264"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#3BBFAD]/20 rounded-full blur-3xl" data-id="element-265"></div>

            <div className="relative z-10 text-center" data-id="element-266">
              {/* Price Display */}
              <div className="mb-10" data-id="element-267">
                <div className="flex items-center justify-center gap-4 mb-4" data-id="element-268">
                  <span className="text-3xl md:text-4xl text-gray-400 line-through font-serif" data-id="element-269">
                    $19
                  </span>
                  <div className="bg-[#F5A623] text-white px-4 py-2 rounded-full text-sm font-bold transform -rotate-3 shadow-lg" data-id="element-270">
                    AHORRA 67%
                  </div>
                </div>

                <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-271">
                  <span className="text-7xl md:text-9xl font-serif font-bold text-white tracking-tighter drop-shadow-2xl" data-id="element-272">
                    $6.36
                  </span>
                </div>

                <div className="inline-flex items-center gap-2 bg-[#3BBFAD]/20 border border-[#3BBFAD] text-[#3BBFAD] px-6 py-2 rounded-full" data-id="element-273">
                  <SparklesIcon className="w-5 h-5" data-id="element-274" />
                  <span className="font-bold text-lg" data-id="element-275">
                    Precio especial de lanzamiento
                  </span>
                </div>
              </div>

              {/* Value Proposition */}
              <div className="max-w-2xl mx-auto mb-12" data-id="element-276">
                <p className="text-2xl md:text-3xl text-white leading-relaxed font-serif mb-6" data-id="element-277">
                  No porque el tema sea "pequeño".
                </p>
                <p className="text-xl text-gray-300 leading-relaxed" data-id="element-278">
                  Sino porque cuando una familia está en duda, lo que necesita
                  es:
                </p>
                <p className="text-3xl font-bold text-[#F5A623] mt-6 font-serif" data-id="element-279">
                  algo claro, rápido y usable hoy.
                </p>
              </div>

              {/* CTA Button - Orange */}
              <div className="space-y-6" data-id="element-280">
                <a href="https://claridapaso.com/cart/48490354213107:1" onClick={() => {
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'La Ruta Clara',
                    content_type: 'product',
                    value: 6.36,
                    currency: 'USD'
                  });
                }
              }} className="inline-flex items-center justify-center gap-3 bg-[#F5A623] text-white px-12 py-6 rounded-full text-2xl font-bold hover:bg-[#E09615] hover:scale-105 transition-all duration-300 shadow-[0_0_40px_rgba(245,166,35,0.5)] hover:shadow-[0_0_60px_rgba(245,166,35,0.7)] border-2 border-[#F5A623]/50" data-id="element-281">
                  <SparklesIcon className="w-7 h-7" data-id="element-282" />
                  Quiero mi Ruta Clara Ahora
                  <ArrowRightIcon className="w-7 h-7" data-id="element-283" />
                </a>

                <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-300" data-id="element-284">
                  <span className="flex items-center gap-2" data-id="element-285">
                    <span className="w-2 h-2 bg-[#3BBFAD] rounded-full" data-id="element-286"></span>
                    Descarga inmediata
                  </span>
                  <span className="hidden md:block text-gray-500" data-id="element-287">•</span>
                  <span className="flex items-center gap-2" data-id="element-288">
                    <span className="w-2 h-2 bg-[#3BBFAD] rounded-full" data-id="element-289"></span>
                    PDF + Imprimibles
                  </span>
                  <span className="hidden md:block text-gray-500" data-id="element-290">•</span>
                  <span className="flex items-center gap-2" data-id="element-291">
                    <span className="w-2 h-2 bg-[#3BBFAD] rounded-full" data-id="element-292"></span>
                    Empieza hoy mismo
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 text-center" data-id="element-293">
            <p className="text-gray-400 text-sm mb-4" data-id="element-294">
              Más de 500 familias ya tienen su Ruta Clara
            </p>
            <div className="flex justify-center gap-8 text-gray-500 text-xs" data-id="element-295">
              <span data-id="element-296">✓ Pago seguro</span>
              <span data-id="element-297">✓ Sin suscripciones</span>
              <span data-id="element-298">✓ Acceso de por vida</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}